import circle from '@turf/circle';
import { findFirstCustomLayer } from './layers';

function addRadiusToMap( ctx, options ) {
    const map = ctx.map;

    let circleFeature = circle( options.center, options.radius, {
        units: 'kilometers',
    } );

    let northernPoint;
    let easternPoint;

    let coords = circleFeature.geometry.coordinates[ 0 ];
    for ( let pointIndex = 0; pointIndex < coords.length; pointIndex++ ) {
        let point = coords[ pointIndex ];
        let latitude = point[ 1 ];
        let longitude = point[ 0 ];

        if ( !northernPoint || latitude > northernPoint[ 1 ] ) {
            northernPoint = point;
        }

        if ( !easternPoint || longitude > easternPoint[ 0 ] ) {
            easternPoint = point;
        }
    }

    // find all points between north and East
    let northEastCorner = coords.filter( function( point ) {
        let lat = point[ 1 ];
        let lon = point[ 0 ];
        return ( ( lat <= northernPoint[ 1 ] && lat >= easternPoint[ 1 ] ) && lon <= easternPoint[ 0 ] && lon >= northernPoint[ 0 ] );
    } );

    // sort points by longitude
    northEastCorner = northEastCorner.sort( function( pointA, pointB ) {
        let lonA = pointA[ 0 ];
        let lonB = pointB[ 0 ];
        return lonA - lonB;
    } );

    // use north-east point
    const nwp = northEastCorner[ northEastCorner.length % 2 === 0 ? northEastCorner.length / 2 : ( northEastCorner.length / 1 ) - 1 ];

    if ( map.getLayer( 'radius:fill' ) ) {
        map.removeLayer( 'radius:fill' );
    }

    if ( map.getSource( 'radius' ) ) {
        map.removeSource( 'radius' );
    }

    map.addSource( 'radius', {
        type: 'geojson',
        data: circleFeature,
        tolerance: 0,
    } );

    if ( map.getLayer( 'radius-close:fill' ) ) {
        map.removeLayer( 'radius-close:fill' );
    }

    if ( map.getSource( 'radius-close' ) ) {
        map.removeSource( 'radius-close' );
    }

    map.addSource( 'radius-close', {
        type: 'geojson',
        data: {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: nwp,
            },
            properties: {
                type: 'eventDispatcher',
                event: 'twc:mapsearch:remove-radius',
                label: ctx.getTemplateString( 'btnClearRadius' ),
            },
        },
    } );

    map.addLayer( {
        id: 'radius:fill',
        source: 'radius',
        type: 'fill',
        paint: {
            'fill-color': '#d0021b',
            'fill-opacity': 0.1,
        },
    }, findFirstCustomLayer( map ) );

    map.addLayer( {
        id: 'radius-close:fill',
        source: 'radius-close',
        type: 'symbol',
        layout: {
            'icon-image': 'close-icon',
            'icon-allow-overlap': true,
        },
    } );

    return circleFeature;
}

/**
 * @param {mapboxgl.Map} ctx - the map context to use
 */
function removeRadiusFromMap( ctx ) {
    if ( ctx.getLayer( 'radius:fill' ) ) {
        ctx.removeLayer( 'radius:fill' );
    }

    if ( ctx.getSource( 'radius' ) ) {
        ctx.removeSource( 'radius' );
    }

    if ( ctx.getLayer( 'radius-close:fill' ) ) {
        ctx.removeLayer( 'radius-close:fill' );
    }

    if ( ctx.getSource( 'radius-close' ) ) {
        ctx.removeSource( 'radius-close' );
    }
}

/**
 * @param {mapboxgl.Map} ctx - the map context to use
 */
function removeRadiusState( ctx, hideSelect = false ) {
    removeRadiusFromMap( ctx );

    const radiusInputs = document.querySelectorAll( '[name=radius]' );

    radiusInputs.forEach( ( input ) => {
        input.value = '';

        if ( input.getAttribute( 'type' ) === 'hidden' ) {
            input.remove();
        }
    } );

    if ( hideSelect ) {
        const selectContainer = document.querySelector( '.searchpopup__location-radius' );

        if ( selectContainer ) {
            selectContainer.classList.add( 'd-none' );
        }
    }
}

export {
    addRadiusToMap,
    removeRadiusFromMap,
    removeRadiusState,
};
